// extracted by mini-css-extract-plugin
module.exports = {"dropdownSidebar":"styles_dropdownSidebar__v3no_","dropdownSidebarVisible":"styles_dropdownSidebarVisible__nLR5M"};